import { errorView, type QueryView } from '@krp/client-runtime'

import { PLACE_NAME_MAX, type ShownError } from './types'

/** Слова раздела. Тексты службы показываются дословно: здесь только то, что говорит сам клиент. */

/** Код занятого названия объекта (договор службы: 409 `schedule-place-name-taken`). */
export const PLACE_NAME_TAKEN_CODE = 'schedule-place-name-taken'

/** Код занятого дня (договор службы: 409 `day_busy`): кассир в этот день уже стоит на другом объекте. */
export const DAY_BUSY_CODE = 'day_busy'

/** Подсказка у клетки, которую клиент знает занятой заранее (по назначениям других объектов), без запроса к службе. */
export function dayBusyHint(busyAt: string): string {
  return `Нельзя: день занят — объект «${busyAt}»`
}

/** Отказ службы «день занят» (409 `day_busy`): показывается вспышкой клетки и подсказкой, а не панелью ошибки. */
export function isDayBusy(error: unknown): boolean {
  return errorView(error).code === DAY_BUSY_CODE
}

/** Отказ запроса или команды: заголовок и дословный ответ службы. */
export function shownError(title: string, error: unknown): ShownError {
  return { title, error: errorView(error) }
}

/**
 * Состояние загрузки нескольких запросов экрана одним видом: первая ошибка важнее загрузки, загрузка важнее готовности.
 * Данные ошибочного запроса экран не рисует как актуальные (F06).
 */
export function combinedView(views: readonly QueryView[]): QueryView {
  const failed = views.find((view) => view.error !== null)
  if (failed !== undefined) return failed
  const loading = views.find((view) => view.status === 'loading' || view.status === 'idle')
  if (loading !== undefined) return { status: 'loading', refreshing: false, error: null }
  return { status: 'ready', refreshing: views.some((view) => view.refreshing), error: null }
}

/** Проверка названия объекта до отправки: что не так, словами; `null` — можно отправлять. */
export function placeNameProblem(name: string): string | null {
  const trimmed = name.trim()
  if (trimmed === '') return 'Введите название объекта — например, адрес магазина.'
  if (trimmed.length > PLACE_NAME_MAX) return `Название объекта — не больше ${PLACE_NAME_MAX} символов.`
  return null
}
